import { makeAutoObservable } from "mobx";
import MixpanelService, { IMixPanelIdentity, MixpanelOptionalProperties } from "../../services/mixpanel.service";
import { rootContainer, TYPE } from "../../services/container/root";
import { RETURN_METHOD_CATEGORY } from "../return-methods/return-method-types";

export enum SBR_PAGE_MIXPANEL_EVENT {
    PAGE_OPENED = 'sbr-page-opened',
    SCHEDULE_DEMO_CLICKED  = 'sbr-page-schedule-demo-clicked',
    VIEW_RATES_CLICKED  = 'sbr-page-view-rates-clicked',
    ADOPTION  = 'sbr-page-adoption',
}

export interface IMixpanelRMData {
    Return_method_name: string,
    Return_method_type: RETURN_METHOD_CATEGORY,
    Shipping_connection: string,
    Linked_policies: number,
    Updated_to_SBR: boolean,
}

class SBRPageMixPanelStore {
    private _identity?: IMixPanelIdentity;
    private _properties: Record<string, any> = {};

    constructor() {
        makeAutoObservable(this, {}, { autoBind: true });
    }

    private get _mixpanelService(): MixpanelService {
        return rootContainer.get<MixpanelService>(TYPE.MixpanelService);
    }

    public setIdentity(identify: IMixPanelIdentity): void {
        this._identity = identify;
        this._properties.shop = identify.shop_name;
    }

    public trackEvent(event: SBR_PAGE_MIXPANEL_EVENT, properties: MixpanelOptionalProperties): void {
        /** wrapped in try catch to make sure it will not break functionality */
        try {
            this._mixpanelService.trackEvent(event, { ...this._properties, ...properties, event_timestamp: Date.now() }, { ...this._identity });
        }
        catch (e) {
            console.error(e);
        }
    }

}

const storeSBRPageMixPanel = new SBRPageMixPanelStore();
export default storeSBRPageMixPanel;